import Vue from 'vue'
import VueRouter from 'vue-router'
import Loader from '../views/util/Loader.vue'
import Login from '../views/util/Login.vue'
import AppIndex from '../views/app/Index.vue'

import appModules from './app'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Loader
  },{
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path : '/app',
    name: 'appSystem',
    component: AppIndex,
    children: appModules
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
